<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="modal-form-block">
                <label for="username">
                    Username:
                </label>
                <input-checker type="text"
                               name="username"
                               placeholder="AlliBraggi"
                               v-model="user.username"
                               url="/api/checker/user?username="
                >

                </input-checker>
            </div>
            <div class="modal-form-block">
                <label for="Name">
                    Nome Completo:
                </label>

                <input type="text"
                       name="name"
                       placeholder="Arnoldo Fogazzari"
                       v-model="user.name"
                       required
                >
            </div>
            <div class="modal-form-block">
                <label for="Email">
                    Email:
                </label>

                <input-checker type="email"
                               name="email"
                               placeholder="alli@fogazzari.com"
                               v-model="user.email"
                               url="/api/checker/user?email="
                >

                </input-checker>
            </div>
            <div class="modal-form-block">
                <label for="Password">
                    Password:
                </label>
                <input type="password"
                       name="name"
                       placeholder="password"
                       v-model="user.password"
                       required
                >
            </div>
            <div class="modal-form-block mb-6">
                <label for="Password">
                    Ripeti Password:
                </label>
                <input type="password"
                       name="name"
                       placeholder="password"
                       v-model="user.password_confirm"
                       required
                >
            </div>
            <div class="modal-form-block mb-6">
                <button class="w-1/3 mx-auto btn is-aitems-700">
                    Crea
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import InputChecker from './InputChecker';

    export default {

        components: {InputChecker},

        data() {
            return {
                user: {
                    username: '',
                    name: '',
                    email: '',
                    password: '',
                    password_confirm: '',
                    lang: 'it',
                    active: true
                },

            }
        },


        methods: {
            onSubmit() {
                console.log('Submitto!')
            },

        }

    }
</script>

